module.exports = __webpack_public_path__ + "static/media/logo.f611f68b.png";